import "./new.scss";
import Sidebar from "../../components/sidebar/Sidebar";
import Navbar from "../../components/navbar/Navbar";
import DriveFolderUploadOutlinedIcon from "@mui/icons-material/DriveFolderUploadOutlined";
import { useState as uState } from "react";

const adminNew = () => {
  const [file, setFile] = uState("");

  return (
    <div className="new">
      <Sidebar />
      <div className="newContainer">
        <Navbar />
        <div className="top">
          <h1>Add New Admin</h1>
        </div>
        <div className="bottom">
          <div className="left">
            <img
              src={
                file
                  ? URL.createObjectURL(file)
                  : "https://icon-library.com/images/no-image-icon/no-image-icon-0.jpg"
              }
              alt=""
            />
          </div>
          <div className="right">
            <form>
              <div className="formInput">
                <label htmlFor="file">
                  Image: <DriveFolderUploadOutlinedIcon className="icon" />
                </label>
                <input
                  type="file"
                  id="file"
                  onChange={(e) => setFile(e.target.files[0])}
                  style={{ display: "none" }}
                />
              </div>
              <div className="formInput">
                <label>Full Name</label>
                <input type="text" placeholder="Purav" />
              </div>
              <div className="formInput">
                <label>Mobile</label>
                <input type="text" placeholder="enter mobile" />
              </div>
              <div className="formInput">
                <label>Email</label>
                <input type="text" placeholder="abc@gmail.com" />
              </div>
              <div className="formInput">
                <label>Address</label>
                <input type="text" placeholder="Sonipat" />
              </div>
              <div className="formInput">
                <label>Nick Name</label>
                <input type="text" placeholder="100" />
              </div>
              <div className="formInput">
                <label>Password</label>
                <input type="text" placeholder="mynamewithdob" />
              </div>
              <div className="formInput">
                <label>Confirm Password</label>
                <input type="text" placeholder="mynamewithdob" />
              </div>
              <button type='submit'>Send</button>
            </form>
          </div>
        </div>
      </div>
    </div>
  );
};

export default adminNew;
